import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const ViewMore = dynamic(() => import('../../../components/ViewMore'));

const WeCorporateSocialResponsibility = props => {
  return (
    <>
      <Head>
        <title>We corporate social responsibility - Prodigi</title>
        <meta
          name="description"
          content="ProDigi is a commercial organization that pursues interests of its own. Nevertheless, as an indefeasible part of a society, our company and each of its members strive to contribute to the community as much as possible. To make an impact, we are working in several directions.                    "
        />
      </Head>
      <main>
        <style global jsx>{`
          .bg-image {
            background-size: cover;
            background-image: url('/images/about/responsibility11.png');
            background-position: center;
          }
          .full-back-image {
            height: 299px;
            background-size: cover;
            background-image: url('/images/about/growing_talent1.png');
            background-position: center;
          }
          @media screen and (max-width: 758px) {
            .bg-image {
              background-image: url('/images/about/responsibility11.png');
            }
            .full-back-image {
              height: 91px;
            }
          }
        `}</style>
        <div className="relative w-full  h-700  overflow-hidden  bg-image">
          <div className="container h-full">
            <h1 className="relative h-full  flex flex-col flex-wrap justify-center items-start ">
              <div className="uppercase text-white text-30 md:text-72 font-black leading-none">WE ARE CORPORATE</div>
              <div className="uppercase text-green text-30 md:text-72 leading-none font-black ">
                SOCIAL <br />
                RESPONSIBILITY
              </div>
            </h1>
          </div>
        </div>
        <div className="body-part">
          <div className="bg-white">
            <div className="container py-30">
              We are tiny particles of the great world working and living for a mission, devoting life, and creating value. ProDigi is a commercial
              organization that pursues interests of its own. Nevertheless, as an indefeasible part of a society, our company and each of its members
              strive to contribute to the community as much as possible. To make an impact, we are working in several directions.{' '}
            </div>
          </div>

          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none font-black uppercase">Raising awareness</h2>
              <p className="mt-20 hidden md:block">
                Despite media availability and constant information flow, there are still problems that need broader coverage and social awareness.
                Our team implements all possible levers of influence to raise awareness and invest in the most sensitive and crucial projects. For
                several years in a row, we have been donating 1% of our approved projects’ profit to various charity projects (Breast Cancer
                Awareness, UNICEF, World Vision).{' '}
              </p>
              <p className="mt-20 block md:hidden">
                <ViewMore ln={60}>
                  Despite media availability and constant information flow, there are still problems that need broader coverage and social awareness.
                  Our team implements all possible levers of influence to raise awareness and invest in the most sensitive and crucial projects. For
                  several years in a row, we have been donating 1% of our approved projects’ profit to various charity projects (Breast Cancer
                  Awareness, UNICEF, World Vision).{' '}
                </ViewMore>
              </p>
            </div>
          </div>

          <div className="bg-white">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none font-black uppercase">Supporting social initiatives</h2>
              <p className="mt-20  ">
                Social initiatives make a powerful impact in society, bringing people around the idea, supporting the target groups, and creating a
                community for the future. We foster social initiatives and endeavor to support them by providing free advertising and information
                spread through various social channels. We have supported and continue encouraging initiatives like anti-smoking campaigns, Covid
                safety measures, the promotion of vaccines, and more.
              </p>
            </div>
          </div>
          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none font-black uppercase">Growing talent pool</h2>
              <p className="mt-20 mb-20 ">
                With rapidly developing technologies and evolving digital world, we lack specialists who assist in creating a value proposition. We
                have found a way to nurture industry professionals that will become valuable assets for our company and the entire digital community.
                Regular internship programs in ProDigi have proven efficiency in filling the gap between knowledge and practice. We give a chance to
                students and graduates to gain experience and get on the path of career growth.
              </p>
              <div className="w-fill h-299 full-back-image" />
            </div>
          </div>
          <div className="bg-white">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none font-black uppercase">Hand in hand in the post-Covid world</h2>
              <p className="mt-20  ">
                The pandemic has divided our lives into pre and post-Covid reality. Moreover, the global paralysis during the lockdown was devastating
                for most businesses. Those that survived and managed to reach post-Covid reality faced other challenges. The digital world has also
                undergone dramatic transformations. Our team understands the power of community and the importance of assisting each other in Force
                Majeure situations. Covid is definitely the most striking crisis that shook the world, and we all needed good friends. ProDigi has
                become a good friend for many businesses providing free support to businesses affected by Covid.
              </p>
            </div>
          </div>
          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none font-black uppercase">Promoting startup growth</h2>
              <p className="mt-20">
                The competitive market is vicious to startups, and even the most creative idea with potential may not survive the competition. We have
                developed a particular collaboration strategy with startups and growing businesses that need a little more contribution and support in
                the first stages of building a reputation. The partnership implies the services chosen by a client as well additional free features to
                boost brand recognition.{' '}
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default WeCorporateSocialResponsibility;
